import * as React from 'react';
import { SelectOption } from 'formComponents/Select/types';
import { useSelector } from 'react-redux';
// eslint-disable-next-line import/no-cycle
import { artikelEigenschaftenSelector } from 'store/lookups/selector';
import { callApi, Controller } from './useApi';

export interface ArtikelEigenschaft {
    eigenschaftKz: string;
    eigenschaftNr: number;
    text: string;
}

export const defaultArtikelEigenschaft: ArtikelEigenschaft = {
    eigenschaftKz: 'M',
    eigenschaftNr: 0,
    text: '',
};

export function useArtikelEigenschaftenAsOptions(): SelectOption[] {
    const artikelEigenschaften = useSelector(artikelEigenschaftenSelector);

    return React.useMemo<SelectOption[]>(() => {
        return artikelEigenschaften.map(
            (artikelEigenschaft) =>
                ({
                    value: artikelEigenschaft.eigenschaftKz + '|' + artikelEigenschaft.eigenschaftNr,
                    label: artikelEigenschaft.eigenschaftKz + ': ' + artikelEigenschaft.text,
                } as SelectOption),
        );
    }, [artikelEigenschaften]);
}

export async function addArtikelEigenschaft(artikelEigenschaft: ArtikelEigenschaft): Promise<void> {
    return callApi<void>(Controller.artikelEigenschaft + '/add', { artikelEigenschaft });
}

export async function updateArtikelEigenschaft(artikelEigenschaft: ArtikelEigenschaft): Promise<void> {
    return callApi<void>(Controller.artikelEigenschaft + '/update', { artikelEigenschaft });
}

export async function deleteArtikelEigenschaft(artikelEigenschaft: ArtikelEigenschaft): Promise<void> {
    return callApi<void>(Controller.artikelEigenschaft + '/update', { artikelEigenschaft });
}
